
import { Map as ImmutableMap } from 'immutable';
import { DateTime } from 'luxon';
import { getVehiclesById } from 'data/vehicles/selectors';
import { createSelector } from 'reselect';

import { REDUCER_KEY } from './reducer';

export const getTripsStore = (state) => state[REDUCER_KEY];
export const getTripsById = (state) => getTripsStore(state).resourcesById;
export const getTripsIsLoading = (state) => getTripsStore(state).isLoading;
export const getLastSyncDate = (state: any) => getTripsStore(state).lastSyncDate;


export const getSortedTripsById = createSelector(
  getTripsById,
  (tripsById) =>
    tripsById.sort((a ,b) => {
      if (DateTime.fromISO(a).toSeconds() > DateTime.fromISO(b).toSeconds()) {
        return -1;
      }
      return 1;
    })
);

export const getTripsByVehicleId = createSelector(
  getTripsById,
  getVehiclesById,
  (tripsById, vehiclesById) =>
    ImmutableMap().withMutations((map) => {
      vehiclesById.forEach((vehicle) => {
        map.set(vehicle.id, tripsById.filter((x) =>
          x.vehicleId === vehicle.id).toList().sort((a ,b) => {
          if (DateTime.fromISO(a).toSeconds() > DateTime.fromISO(b).toSeconds()) {
            return -1;
          }
          return 1;
        }));
      });
    })
);
